import { render, staticRenderFns } from "./InviraUserCreate.vue?vue&type=template&id=005be2e6&scoped=true"
import script from "./InviraUserCreate.vue?vue&type=script&lang=js"
export * from "./InviraUserCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005be2e6",
  null
  
)

export default component.exports